export enum BuildingStatusAPIResponse {
  Development = 'development',
  Construction = 'construction',
  Complete = 'complete',
  NoPlans = 'noPlans',
  Redevelopment = 'redevelopment',
}
